"use client";

import { useWaitlistCount } from "@nomiss/hooks";

const avatars = [
  { initial: "R", className: "bg-[#A12D2F]" },
  { initial: "A", className: "bg-[#A12D8F]" },
  { initial: "S", className: "bg-[#9A7325]" },
  { initial: "P", className: "bg-[#76730D]" },
] as const;

export function SocialProof() {
  const { waitlistCountQuery } = useWaitlistCount();
  const count = waitlistCountQuery.data?.data?.count ?? 0;
  const isLoading = waitlistCountQuery.isLoading;
  const isError = waitlistCountQuery.isError;

  if (isError) {
    return null;
  }

  if (isLoading) {
    return (
      <div className="flex flex-wrap items-center gap-x-3 gap-y-2">
        <div className="flex shrink-0 -space-x-2">
          {Array.from({ length: 4 }).map((_, i) => (
            <span
              key={i}
              className="border-background flex size-8 animate-pulse items-center justify-center rounded-full border-2 bg-gray-700 sm:size-9"
            />
          ))}
        </div>
        <p className="min-w-0 text-sm leading-snug text-gray-400 sm:text-base">
          <span className="bg-muted inline-block h-4 w-36 animate-pulse rounded" />
        </p>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-x-2 gap-y-2">
      <div className="flex shrink-0 -space-x-2">
        {avatars.map((avatar) => (
          <span
            key={avatar.initial}
            className={`border-background flex size-8 items-center justify-center rounded-full border-2 text-[11px] font-semibold text-white sm:size-9 sm:text-xs ${avatar.className}`}>
            {avatar.initial}
          </span>
        ))}
      </div>

      <p className="min-w-0 text-xs leading-snug text-gray-400 sm:text-sm">
        {count <= 500
          ? `Join the fans already on the waitlist.`
          : count > 500 && count < 1000
            ? `Join the fans, ${count} already on the waitlist.`
            : "1000+ fans already In"}
      </p>
    </div>
  );
}
